import { OrderHeader } from "@core/models/order-header.model";
import { OrderStatusViewModel } from "@shared/viewModels/order-status.viewModel";

export class OrderHeaderViewModel {
	id: string = "";
	customerName: string = "";
	campaignName: string = "";

	statusVM!: OrderStatusViewModel;

	currencyCode: string | undefined;
	net: number | undefined;

	products: string | undefined;
	placements: string | undefined;
	sizes: string | undefined;

	startDate: string = "";
	endDate: string = "";
	nextDate: string = "";
	adCount: string = "";
	adCountRemaining: string = "";
	poNumber: string = "";

	thumbnail: string | undefined;

	agencyContactId: string | undefined;
	otherPayerId: string | undefined;
	otherPayerName: string | undefined;

	contactFirstName: string | undefined;
	contactLastName: string | undefined;
	contactEmail: string | undefined;
	contactPhone: string | undefined;

	// Note: those flags are mutually exclusive. Set only one of them.
	isConfirmationDeadlineApproaching: boolean = false;
	isConfirmationDeadlinePassed: boolean = false;

	orderHeader: OrderHeader;

	constructor (orderHeader: OrderHeader) {
		this.orderHeader = orderHeader;
	}
}
